import React from 'react'
import UserBioCard from '../components/UserBioCard'
import SEO from '../components/SEO'
import ScrollToTop from '../components/ScrollToTop'

const team = () => {
  return (
    <>
      <SEO 
        title="WeFlare Team"
        description="Meet our team" 
        keywords="WeFlare team, Youth Leaders Kenya, Youth Advocates Kenya, Vivian Njambi, Alex Mavuti, Kiyo Mwangi"
        url="https://weflare.org/team"
      />
      <ScrollToTop />
      <div className="bg-pattern-light py-3">
        <div class="container page-length">
        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="text1 text-center">Meet Our Team</h1>
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
            <UserBioCard
              userSlug="njambi-kinyungu"
              styleImage={{objectFit: 'cover'}} 
            />
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
            <UserBioCard
              userSlug="alex-mavuti"
              styleImage={{objectFit: 'cover'}} 
            />
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
            <UserBioCard
              userSlug="vivian-njambi"
              styleImage={{objectFit: 'cover'}} 
            />
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
            <UserBioCard
              userSlug="kiyo-mwangi"
              styleImage={{objectFit: 'cover'}} 
            />
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
            <UserBioCard
              userSlug="katrine"
              styleImage={{objectFit: 'cover'}} 
            />
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
            <UserBioCard
              userSlug="delivce"
              styleImage={{objectFit: 'cover'}} 
            />
          </div>
        </div>
      </div>
      </div>
    </>
  )
}

export default team